module.exports = __webpack_public_path__ + "img/cta.0b0008f2.png";